<template>
  <div>
    <section>
      <van-nav-bar
        title=""
        left-arrow
        left-text="7000万人都在看"
        :border="false"
        @click-left="onClickLeft"
        style="background: #f8f8f8"
      >
        <template #right>
          <div class="top-recmm" @click="onClickRight">
            <p
              style="
                margin-right: 20px;
                color: #164a9a;
                font-size: 12px;
                padding: 0px 4px;
                border: 1px solid #164a9a;
                border-radius: 12px;
              "
            >
              精彩业务推荐
            </p>
          </div>
        </template>
      </van-nav-bar>
    </section>
    <section>
      <div class="contents">
        <div class="photocentent">
          <van-form @submit="onSubmit">
            <div class="s">
              <input
                class="input"
                placeholder="7000万人都在看"
                v-model="searchValue"
              />
              <button class="sbtn" type="submit">搜索</button>
            </div>
          </van-form>
          <div class="send">搜索"{{ searchValue }}"的结果</div>
          <div class="search_list">
            <section class="newsList" v-if="!loading">
              <router-link
                :to="{ name: 'news', params: { id: v.id } }"
                class="news-item"
                style="padding-top: 0.4rem"
                v-for="(v, k) in newList"
                :key="k"
              >
                <div class="right-content" style="width: 100%">
                  <div
                    class="subject"
                    v-html="highlightKeyword(v.title, searchValue)"
                  ></div>
                </div>
              </router-link>
            </section>
            <div v-if="loading" class="Pageloading">
              <van-loading size="24" color="#007aff" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer1></footer1>
  </div>
</template>

<script>
import footer1 from "@/components/footer";
import { queryArticlesByKeyword } from "../commJs/articles";

export default {
  data() {
    return {
      loading: true,
      searchValue: "",
      newList: [],
      page: 1,
    };
  },
  watch: {
    $route: function () {
      this.loading = true;
      this.newList = [];
      let keys = this.$route.params.keys;
      this.searchValue = keys;
      this.getSearch(keys);
    },
  },
  components: {
    footer1,
  },
  methods: {
    getIndex() {},
    onClickLeft() {
      if (window.history.length > 1) {
        this.$router.go(-1);
        return;
      }
      this.$router.push({ name: "index" });
    },
    onClickRight() {
      const route = this.$router.resolve({ name: "smsplan" });
      window.open(route.href, "_blank");
    },
    onSubmit() {
      const keys = String(this.searchValue || "").trim();
      if (!keys) return;

      this.page = 1;

      // 关键词未变时路由不会触发 watch，需直接重新搜索
      if (String(this.$route.params.keys) === keys) {
        this.loading = true;
        this.newList = [];
        this.getSearch(keys);
        return;
      }

      this.$router.push({
        name: "search",
        params: { keys },
      });
    },
    getSearch(k) {
      queryArticlesByKeyword(k, 20, parseInt(this.page))
        .then((list) => {
          this.loading = false;
          this.newList = list;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    highlightKeyword(text, keyword) {
      if (!text) return "";
      const escapeHtml = (str) =>
        String(str)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;");
      const escapedText = escapeHtml(text);
      const trimmed = String(keyword || "").trim();
      if (!trimmed) return escapedText;
      const pattern = trimmed.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return escapedText.replace(
        new RegExp(pattern, "gi"),
        (match) => `<font color="red">${match}</font>`,
      );
    },
  },
  mounted() {
    let keys = this.$route.params.keys;
    this.searchValue = keys;
    this.getSearch(keys);
  },
};
</script>

<style scoped lang="less">
.contents {
  min-height: 60vh;
}
::v-deep .van-nav-bar__text {
  font-size: 0.34667rem !important;
  color: #666 !important;
}
::v-deep.van-nav-bar .van-icon {
  font-size: 0.34667rem !important;
  color: #666 !important;
}
.photocentent {
  padding: 10px;
}

.photocentent .s {
  margin-top: 10px;
  display: flex;
}

.photocentent .input {
  font-size: 14px;
  width: calc(100% - 100px);
  border: 1px solid #ddd;
  height: 35px;
  line-height: 35px;
  padding: 0 5px;
  color: #444;
}

.photocentent .sbtn {
  background: #4b555f;
  color: #fff;
  width: 90px;
  height: 37px;
  font-size: 16px;
  text-align: center;
  line-height: 37px;
  border: none;
  padding: 0;
  cursor: pointer;
}

.send {
  font-size: 14px;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.search_list {
  .subject span {
    color: red;
  }
}
</style>
